import React, { forwardRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SlidePreview = forwardRef(({ images = [] }, ref) => {
  const settings = {
    dots: images.length > 1,
    infinite: images.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    afterChange: () => {},
    appendDots: (dots) => (
      <div style={{ position: "absolute", bottom: "15px", width: "100%" }}>
        <ul style={{ margin: "0", padding: "0" }}>{dots}</ul>
      </div>
    ),
  };

  if (images.length === 1) {
    return (
      <div className="relative">
        <div className="flex justify-center relative">
          <img
            src={images[0]}
            alt="Tutorial content"
            className="w-full h-80 object-cover rounded-xl"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="relative">
      <Slider ref={ref} {...settings}>
        {images.map((img, index) => (
          <div key={index} className="flex justify-center relative">
            <img
              src={img}
              alt={`Tutorial ${index + 1}`}
              className="w-full h-80 object-cover rounded-xl"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
});

export default SlidePreview;
